// Mock data for Krupal Chaudhary's TEDx Personal Website

export const PROFILE = {
  name: "Krupal Chaudhary",
  title: "Entrepreneur · Author · AI Product Builder · TEDx Speaker",
  tagline: "AI is Not the Future - It is the Operating System of Now",
  age: 25,
  location: "Ahmedabad, India",
  email: "krupal@demazetech.com",
  phone: "+91 70166 60537",
  linkedin: "https://linkedin.com/in/krupalchaudhary",
  website: "demazetech.com",
  photos: {
    hero: "https://customer-assets.emergentagent.com/job_4e744562-a570-46fa-ae2d-5c7ffe8554ae/artifacts/adld536k_WhatsApp%20Image%202026-03-10%20at%2016.53.21.jpeg",
    working: "https://customer-assets.emergentagent.com/job_4e744562-a570-46fa-ae2d-5c7ffe8554ae/artifacts/apmlbjxs_WhatsApp%20Image%202026-03-10%20at%2016.55.04.jpeg",
    dubai: "https://customer-assets.emergentagent.com/job_4e744562-a570-46fa-ae2d-5c7ffe8554ae/artifacts/leg4kf40_WhatsApp%20Image%202026-03-10%20at%2016.56.24.jpeg",
    beach: "https://customer-assets.emergentagent.com/job_4e744562-a570-46fa-ae2d-5c7ffe8554ae/artifacts/7zmyh0xc_WhatsApp%20Image%202026-03-10%20at%2016.52.09.jpeg"
  }
};

export const IMPACT_STATS = [
  { value: "3M+", label: "LinkedIn Impressions", description: "Organically grown" },
  { value: "40+", label: "Global Clients", description: "India, UK, US, AU, NZ" },
  { value: "$25M+", label: "Client Revenue", description: "Generated for clients" },
  { value: "35+", label: "Team Members", description: "Grown from 2" },
  { value: "95%", label: "Client Retention", description: "Trust & excellence" },
  { value: "$1.5M+", label: "Revenue for Demaze", description: "Aiming for bigger impact" }
];

export const VENTURES = [
  {
    name: "Demaze Tech Studio",
    role: "Co-founder & CEO",
    period: "2021 – Present",
    description: "AI-driven software company building enterprise automation, autonomous decision intelligence, and generative AI products. Bootstrapped from zero to a 35-member team with $1.5M+ revenue.",
    highlights: [
      "Mercedes-Benz India's largest Dealers: Reduced staff 500→100, costs down 45%, turnaround down 95%",
      "AI-Native Headless Commerce at 70–95% lower cost than market",
      "Generative AI Storyboard Platform for Film & Advertising",
      "CXO Decision Intelligence Platform",
      "AI Workflow & Risk Management Platform"
    ],
    tag: "AI · Enterprise · Product",
    website: "demazetech.com",
    color: "#E62B1E"
  },
  {
    name: "Designer Kids Club",
    role: "Strategy & Tech Development Partner",
    period: "Oct 2024 – Present",
    description: "UK-based circular luxury kids' fashion platform. Co-led a $3M seed fundraise and built the AI-powered product and technology architecture.",
    highlights: [
      "Co-led $3M seed round",
      "AI-powered circular luxury fashion platform",
      "Built full product and technology architecture"
    ],
    tag: "Fashion · AI · UK",
    color: "#1A1A1A"
  },
  {
    name: "e-Dost",
    role: "Co-founder",
    period: "2020 – 2021",
    description: "Mental health community platform that secured Rs.12 lakhs government startup grant. A formative learning experience that shaped Krupal's approach to purpose-driven building.",
    highlights: [
      "Rs.12 Lakhs government startup grant",
      "Mental health community focus",
      "Foundation for Demaze's values"
    ],
    tag: "Mental Health · Social · Gov. Grant",
    color: "#4A4A4A"
  }
];

export const RECOGNITIONS = [
  {
    title: "LinkedIn News India Feature",
    body: "Featured by LinkedIn News India (7.5M+ followers) for insights on career growth and entrepreneurship.",
    icon: "Globe"
  },
  {
    title: "Startup Mentor & Judge",
    body: "Advised 20+ startups and served as a judge for the Student Startup and Innovation Policy (SSIP), Gujarat.",
    icon: "Award"
  },
  {
    title: "NASA Astronaut Training Experience",
    body: "Selected as a participant in NASA's advanced technology and space exploration programme.",
    icon: "Rocket"
  },
  {
    title: "Meta Developer Day 2023",
    body: "Engaged with VP of Meta India and core teams on AI and XR in Bangalore.",
    icon: "Code2"
  },
  {
    title: "Audience Reports Media Magazine",
    body: "Recognised for expertise in the 'Art of Selling' - positioning, persuasion, and product story.",
    icon: "BookOpen"
  },
  {
    title: "KaroStartup Feature",
    body: "Featured as a recognised young technology entrepreneur in the Indian startup ecosystem.",
    icon: "MapPin"
  }
];

export const SOCIAL_IMPACT = [
  {
    org: "Tathya Foundation",
    role: "Founding Member",
    description: "Providing education, career guidance, and digital literacy to 500+ underprivileged students across Gujarat.",
    stat: "500+ students impacted"
  },
  {
    org: "Waste Free Ahmedabad",
    role: "Initiative Leader",
    description: "Want to lead a city-wide community initiative on sustainable waste management, engaging hundreds of citizens.",
    stat: "City-wide initiative"
  }
];

export const QUOTES = [
  {
    text: "India doesn't need people who believe in it after it succeeds. It needs people who believed before.",
    context: ""
  },
  {
    text: "The people compounding in 2026 aren't the smartest in the room. They're the ones closing feedback loops fastest.",
    context: "LinkedIn · 128+ engagements"
  },
  {
    text: "I'm glad I tried, failed, and persisted. Those failures were the learning for the startup that worked.",
    context: "On two failed startups"
  },
  {
    text: "Growth is loud. But alignment is quiet - and a lot harder to hear. Success doesn't silence the inner chaos. It amplifies it.",
    context: "On the weight of building"
  }
];

export const JOURNEY_MILESTONES = [
  { year: "2000", event: "Born in Gujarat. Grew up with a stammer." },
  { year: "2011", event: "Won district-level eloquence competition. Turned the stammer into a power." },
  { year: "2017", event: "Visited NASA. Sparked a lifelong curiosity about technology." },
  { year: "2018", event: "Started B.Tech in Computer Engineering at L.D. College, Ahmedabad." },
  { year: "2020", event: "Co-founded e-Dost (mental health platform). Secured Rs.10L govt grant. Learned, failed, reset." },
  { year: "2021", event: "Founded Demaze Tech Studio in 3rd year of college. 2 people. 0 clients. 1 vision." },
  { year: "2023", event: "MBA Fellowship in Product Management (GGI). GITEX Global Dubai visit." },
  { year: "2024", event: "Became Strategy & Tech Partner at Designer Kids Club, UK. Co-led $3M seed raise." },
  { year: "2026", event: "Built a 35+ member team, generated $25M+ in client revenue, and provided mentorship and internships to 500+ students." }
];

export const TOPICS = [
  "AI Adoption & Agentic Systems",
  "Entrepreneurship in India",
  "AI & the Future of Work",
  "Value-Driven Company Building",
  "India's Technological Moment",
  "Surviving Failure",
  "Services-to-Product Transition",
  "Founders' Wellbeing"
];

export const EDUCATION = [
  {
    degree: "B.Tech in Computer Engineering",
    institution: "L.D. College of Engineering, Ahmedabad",
    period: "2018 – 2022"
  },
  {
    degree: "MBA Fellowship in Product Management",
    institution: "Global Governance Initiative (GGI)",
    period: "2023"
  }
];
